import { Config } from "@spartacus/core";

export const defaultOccUserAccountConfig: Config = {
  backend: {
    occ: { endpoints: { user: 'current-user' } },
  },
};
